import React from 'react';

import * as styles from './RatingTabs.scss';
import Tab from '../Tab';
import FilterDirection from '../FilterDirection/FilterDirectionHOC';

const RatingTabs = (props) => {
  const {
    tabs,
    groupId,
    handleTabChange,
  } = props;

  return (
    <div className={styles.tabContainer}>
      <div className={styles.tabs}>
        {tabs.map(tab => (
          <Tab
            key={tab.id}
            id={tab.id}
            isActive={tab.id === groupId}
            onClick={(event) => {
              handleTabChange(tab.id, event);
            }}
          >
            {tab.label}
          </Tab>
        ))}
      </div>
      <div className={styles.direction}>
        <FilterDirection />
      </div>
    </div>
  );
};

export default RatingTabs;
